import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import Typography from '#web-components/components/Typography';

import styles from './AccountType.styles';

export interface AccountTypeProps {
  isSelected: boolean;
  onClick: () => void,
  title: string;
  icon: React.ReactNode;
  className?:string;
  disabled?: boolean;
  dataXpath?: string;
}

const useStyles = makeStyles(styles, { name: 'AccountType' });

export default function AccountType({
  isSelected,
  onClick,
  disabled,
  title,
  icon,
  className,
  dataXpath,
}: AccountTypeProps) {
  const classes = useStyles();
  return (
    <Box
      className={clsx(
        classes.root,
        className,
        isSelected && classes.selected,
        disabled && classes.disabled,
      )}
      onClick={onClick}
      data-xpath={dataXpath}
    >
      <span>{icon}</span>
      <Typography className={classes.title} variant="textRegular">{title}</Typography>
    </Box>
  );
}
